import { render, staticRenderFns } from "./ProductSalesPerSegmentReport.vue?vue&type=template&id=57903099&"
import script from "./ProductSalesPerSegmentReport.vue?vue&type=script&lang=js&"
export * from "./ProductSalesPerSegmentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports